import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import appServices from "../../../services/app-services/appServices";
import { convertUserImage } from "../../../util/utils";
import { convertHeicToJpeg, getFileExtenction } from "../../../common/files";
import { imageAcceptedExtension, validateImage } from "../../../common/images";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import SubmitButton from "../../../components/SubmitButton";
import ButtonPrimary from "../../../components/ButtonPrimary";
import LoadingModal from "../../../components/LoadingModal";
import MessageModal from "../../../components/Models/GreenCity/MessageModal";
import { ErrorMessageModal } from "../../../components/ErrorMessageModal";
import SeclectGroup from "../../../components/GreenCity/SeclectGroup";
import {
  Avatar,
  Box,
  TextField,
  Typography,
  Checkbox,
  Button,
  Select,
  MenuItem,
  FormControlLabel
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../../common/colors";
import { styles } from "../../styles";
import style from "./styles";

const defaultImage = require("../../../assets/images/default.png")

const PaymentReimbursement = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const [loading, setLoading] = useState<boolean>(false);

  const [description, setDescription] = useState<string>("");
  const [checkbox1, setCheckbox1] = useState<boolean>(false);
  const [checkbox2, setCheckbox2] = useState<boolean>(false);
  const [selectedGroup, setGroup] = useState<any>(null);
  const [selectedGroupIcon, setSelectedGroupIcon] = useState<any>(defaultImage);
  const [showGroups, setShowGroups] = useState<boolean>(false);
  const [year, setYear] = useState<string>("");
  const [month, setMonth] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [paymentDestination, setPaymentDestination] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string[]>([]);
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState<boolean>(false);

  const initialErrors = {
    group:"",
    amount: "",
    payment_date: "",
    receipt_id: "",
    image: "",
    paymentDestination: "",
    details: "",
    message: "",
  };

  const [errors, setErrors] = useState<any>(initialErrors);

  // Options for the dropdowns
  const years = Array.from({ length: 50 }, (_, i) => 2024 + i); // Years from 1970 to 2020
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // Months 1 to 12
  const [dates, setDates] = useState(Array.from({ length: 31 }, (_, i) => i + 1)); // Dates 1 to 31

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedGroup?.id) {
      appServices.getGroupIcon(selectedGroup.id).then(blob => {
        const file = new File([blob], selectedGroup.group_icon, { type: blob.type });
        setSelectedGroupIcon(URL.createObjectURL(file));
      }).catch(() => {
        console.error("Failed to get group icon image")
        setSelectedGroupIcon(defaultImage);
      })
    }
  }, [selectedGroup]);

  useEffect(() => {
    const daysInMonth = new Date(Number(year), Number(month), 0).getDate()
    setDates(Array.from({ length: daysInMonth }, (_, i) => i + 1))
  }, [year, month]);

  useEffect(() => {
    if (!year || !month || !date) return
    setErrors({...errors, payment_date: ""})
  }, [year, month, date]);

  const handleDescriptionChange = (event: any) => {
    setErrors((prev: any) => ({ ...prev, details: "" }));
    setDescription(event.target.value);
  };

  const handlePaymnetDestinationChange = (event: any) => {
    setErrors((prev: any) => ({ ...prev, paymentDestination: "" }));
    setPaymentDestination(event.target.value);
  };

  const handleCheckbox1Change = (event: any) => {
    setCheckbox1(event.target.checked);
  };

  const handleCheckbox2Change = (event: any) => {
    setCheckbox2(event.target.checked);
  };

  const handleImageUpload = (event: any) => {
    if (!event.target.files) {
      console.error("ファイルを取得できませんでした。", event)
      return
    }

    const selectedFiles: any[] = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      return
    }

    // 入力チェック
    let errMsg = ""
    for (let file of selectedFiles) {
      errMsg = validateImage(file)
      if (errMsg) {
        break
      }
    }

    if (errMsg) {
      setErrors((prev: any) => ({ ...prev, image: errMsg }));
    } else {
      setErrors((prev: any) => ({ ...prev, image: "" }));

      // 選択されたファイルをセット
      const newImages = selectedFiles.map((file: any) => {
        if (getFileExtenction(file) === "heic") {
          return new Promise(async (resolve, reject) => {
            convertHeicToJpeg(file)
              .then((f: File) => resolve(f))
              .catch((e: any) => reject(e))
          })
        } else {
          let reader = new FileReader();
          return new Promise((resolve) => {
            reader.onload = (e: any) => {
              resolve(file);
            };
            reader.readAsDataURL(file);
          });
        }
      });

      Promise.all(newImages).then((loadedImages) => {
        setSelectedFile(loadedImages[0]);
        // setError(null); // Clear any previous error
      }).catch((e: any) => console.error(e));
    }
  };

  const invalidForm = () => {
    const newError = initialErrors

    if (!selectedGroup) newError.group = `${T("group")}${T("error_select")}`
    if (!amount) newError.amount = `${T("payment_amount")}${T("error_enter")}`
    if (!year || !month || !date) newError.payment_date = `${T("reimbursement_payment_date")}${T("error_enter")}`
    if (!paymentDestination) newError.paymentDestination = `${T("payment_address")}${T("error_enter")}`
    if (!selectedFile) newError.image = `${T("reimbursement_image")}${T("error_upload")}`
    if (!description) newError.details = `${T("payment_details")}${T("error_enter")}`

    setErrors(newError)
    return Object.values(newError).some((item: any) => item !== "")
  }

  const handleSubmit = async () => {
    if (invalidForm()) {
      window.scrollTo(0, 0);
      return false
    };

    const selectedDate = year + "-" + month + "-" + date;

    const body = {
      member_group_id: selectedGroup?.id,
      amount: amount,
      payment_date: selectedDate,
      receipt_id: "recipt_attached",
      image: selectedFile,
      payment_address: paymentDestination,
      details: description,
    };

    try {
      setLoading(true);
      const res = await appServices.paymentReimbursementsAdd(body);
      if(res.success){
        setMessage(T("reimbursement_succeed_in_create"))

        setTimeout(() => {
          setMessage("");
          navigate('/reimbursements')
        }, 3099);
      }
      return true
    } catch (error: any) {
      console.error(error)
      const errorResponse = error?.response?.data?.message
      setErrorMessage(errorResponse || [T("api_unknown_error")])
      setOpenErrorMessageModal(true);
      return false
    } finally {
      setLoading(false);
    }
  };

  const handleChangeAmount = (value: string) => {
    if (Number.isNaN(Number(value))) return
    setAmount(Number(value))

    setErrors((prev: any) => ({ ...prev, amount: "" }));
  }

  return (
    <Box>
      <LoadingModal visible={loading} />
      <Box sx={style.headerBox}>
        <GCBackButton onClick={() => navigate(-1)} />
        <Box sx={style.rowMargin}>
          <Avatar src={convertUserImage(user.image)} sx={{ ...style.avatar, width: "30px" }} />
          <Typography>{T("reimbursement")}</Typography>
        </Box>
      </Box>

      <Box sx={{ ...style.container, backgroundColor: colors.farm_gray15 }}>
        <Typography sx={style.titleSeprator}>{T("payment_address")}</Typography>

        {!showGroups && selectedGroup && (
          <Box style={style.marginTB}>
            <Typography style={{ fontWeight: "700" }}>
              <img
                src={selectedGroupIcon}
                alt={"img"}
                style={{
                  ...styles.farmProfileIcon,
                  height: 40,
                  width: 40,
                  margin: 0,
                }}
              />
              &nbsp;{selectedGroup?.name}
            </Typography>
          </Box>
        )}

        <Box>
          {showGroups && (
            <div style={{paddingBottom:20}}>
              <SeclectGroup
                onNext={(group) => {
                  setGroup(group);
                  setShowGroups(false);
                  setErrors((prev: any) => ({ ...prev, group: "" }))
                }}
              />
            </div>
          )}

          {!showGroups && (
            <ButtonPrimary
              title={T("select_group")}
              onClick={() => setShowGroups(true)}
            />
          )}
          {errors.group && <Typography style={{ color: "red" }}>{errors.group}</Typography>}
        </Box>

        <Typography sx={style.titleSeprator}>{T("reimbursement_content")}</Typography>
        <Box>
          <Box sx={{ marginTop: "10px" }}>
            <Typography>{T("reimbursement_image_description1")}</Typography>
            {!selectedFile ? (
              <Typography sx={style.subtitle}>
                {T("reimbursement_image_description2")}
              </Typography>
            ) : (
              <Box sx={style.imageContainer}>
                <img style={style.image} src={URL.createObjectURL(selectedFile)} alt="" />
              </Box>
            )}
          </Box>
          {errors.image && <Typography sx={style.error} color="error">{errors.image}</Typography>}

          <Button
            color={errors.image ? "error" : "secondary"}
            sx={style.uploadImageButton}
            component="label"
            variant="outlined"
          >
            {T("reimbursement_upload_image")}
            <input accept={imageAcceptedExtension} type="file" hidden onChange={handleImageUpload} />
          </Button>

          <Box
            sx={{
              ...style.container,
              backgroundColor: colors.farm_white,
              borderRadius: 2,
              marginBottom: "20px",
            }}
          >
            <Typography sx={style.smallText}>{T("reimbursement_payment_date")}</Typography>
            {errors.payment_date && (
              <Typography sx={style.smallText} color={"error"}>
                {errors.payment_date}
              </Typography>
            )}

            <Box sx={style.dateContainer}>
              <Select
                error={!!errors.payment_date && !year}
                value={year}
                onChange={(e) => setYear(e.target.value)}
                displayEmpty
                sx={{ width: "33%", backgroundColor: "white" }}
              >
                <MenuItem value="" disabled>
                  {year} {T("year")}
                </MenuItem>
                {years.map((yr) => (
                  <MenuItem key={yr} value={yr}>
                    {yr}
                  </MenuItem>
                ))}
              </Select>

              <Select
                error={!!errors.payment_date && !month}
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                displayEmpty
                sx={{ width: "33%", backgroundColor: "white" }}
              >
                <MenuItem value="" disabled>
                  {month} {T("month")}
                </MenuItem>
                {months.map((mn) => (
                  <MenuItem key={mn} value={mn}>
                    {mn}
                  </MenuItem>
                ))}
              </Select>

              <Select
                error={!!errors.payment_date && !date}
                value={date}
                onChange={(e) => setDate(e.target.value)}
                displayEmpty
                sx={{ width: "33%", backgroundColor: "white" }}
              >
                <MenuItem value="" disabled>
                  {date} {T("day")}
                </MenuItem>
                {dates.map((dt) => (
                  <MenuItem key={dt} value={dt}>
                    {dt}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={style.separator} />

            <Typography sx={style.smallText}>{T("payment_address")}</Typography>

            <TextField
              error={!!errors.paymentDestination}
              helperText={errors.paymentDestination}
              sx={{
                marginBottom: "10px",
                width: "100%",
                backgroundColor: "white",
              }}
              placeholder={`${T("reimbursement_payment_address_example")}`}
              hiddenLabel
              value={paymentDestination}
              onChange={handlePaymnetDestinationChange}
              inputProps={{ maxLength: 500 }}
            />
            <Box sx={style.separator} />

            <Typography sx={style.smallText}>{T("required_amount")}</Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                className="amount-input"
                value={amount}
                error={!!errors.amount}
                helperText={errors.amount}
                multiline
                style={{ textAlign: "right" }}
                sx={{
                  marginBottom: "10px",
                  width: "100%",
                  backgroundColor: "white",
                }}
                placeholder="1,000"
                hiddenLabel
                type={"text"}
                onChange={(e) => handleChangeAmount(e.target.value)}
                inputProps={{ maxLength: 500 }}
              />
              <Typography sx={style.smallText}>{T("unit_yen")}</Typography>
            </Box>
          </Box>
        </Box>

        <Typography sx={style.titleSeprator}>{T("payment_details")}</Typography>
        <TextField
          error={!!errors.details}
          helperText={errors.details}
          required
          multiline
          sx={style.inputField}
          placeholder={`${T("reimbursement_details_example")}`}
          hiddenLabel
          inputProps={{ maxLength: 500 }}
          value={description}
          rows={2}
          onChange={handleDescriptionChange}
        />
      </Box>

      <Box sx={style.container}>
        <Typography sx={style.titleSeprator}>{T("notice")}</Typography>
        <Box sx={{ ...style.row, marginTop: "10px" }}>
          <FormControlLabel
            control={<Checkbox checked={checkbox1} onChange={(e) => handleCheckbox1Change(e)} />}
            color="error"
            label={T('reimbursement_check1')}
          />
        </Box>
        <Box sx={style.row}>
          <FormControlLabel
            control={<Checkbox checked={checkbox2} onChange={(e) => handleCheckbox2Change(e)} />}
            color="error"
            label={T('reimbursement_check2')}
          />
        </Box>
      </Box>

      <MessageModal
        onContinue={() => {}}
        message={message}
        open={message.length > 0}
        onClose={() => setMessage("")}
      />

      <ErrorMessageModal
        messages={errorMessage}
        open={openErrorMessageModal}
        onClose={() => setOpenErrorMessageModal(false)}
      />

      <SubmitButton
        validate={async () => true}
        disabled={!checkbox1 || !checkbox2}
        color="secondary"
        sx={style.submitButton}
        size={"large"}
        variant="outlined"
        onSubmit={handleSubmit}
        endIcon={<FontAwesomeIcon style={style.endIcon} icon={faChevronRight} />}
      >
        {T("reimbursement_submit")}
      </SubmitButton>
    </Box>
  );
};

export default PaymentReimbursement;
